<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> dashboard_customize </v-icon>
      <span :class="ui.textHeadline"> Licence </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Licence, terms of use, data privacy detail . Subscription expiry date.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-btn :color="ui.btnColor" flat dark
        v-if="!this.enableNew">
          <v-icon left> account_balance </v-icon> new
        </v-btn>
        <CompanyNew
        v-if="
        this.enableNew &&
        this.licenceOKCompanyNew &&
        this.userOK &&
        this.getUser.basic.act === true &&
        this.getUser.basic.title !== ''
        "/>
        <v-spacer/>
        <LicenceCard :data="{
          title: 'review',
          icon: 'create',
          colorTitle: this.ui.textSubheadingBoldBlue,
          colorIcon: this.ui.colorBlue}"
          />
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import LicenceCard from "@/admin/licence/components/LicenceCard";
import CompanyNew from "@/company/company/components/CompanyNew";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions],
  components: {
    CompanyNew,
    LicenceCard
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  mounted() {
    setTimeout(() => {
      this.enableNew = true;
    }, 500);
  },
  data() {
    return {
      valid: true,
      enableNew: false
    };
  }
};
</script>
